import React from "react";
import styled from "styled-components";
import Mikkee from "../../../../assets/images/Mikkee.png";
import CeoSignature from "../../../../assets/images/signature.png";
import LoginTopImg from "../../../../assets/images/login-top-img.png";
import CloseBtn from "../../../../assets/icons/x-close.svg";
import AppContext from "../../../../AppContext";

//#region Styled Components
const StyledWelcomeDialog = styled.div`
    &.popup,
    &.popup * {
        box-sizing: border-box;
    }
    &.popup {
        background: #141922;
        border-radius: 20.33px;
        display: flex;
        flex-direction: column;
        gap: 40.67px;
        align-items: center;
        justify-content: flex-start;
        height: 885px;
        position: sticky;
        overflow: hidden;
        backdrop-filter: blur(63.55px);
        height: 85vh;
        overflow-y: auto;
        max-height: 892px;
    }
    .frame-1000011177 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-427319123 {
        background: linear-gradient(233.88deg, rgba(41, 49, 63, 1) 0%, rgba(61, 69, 83, 1) 100%);
        padding: 68.54px 40.67px 40.67px 40.67px;
        display: flex;
        flex-direction: column;
        gap: 20.33px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        width: 659px;
        position: relative;
    }
    .frame-1000011398 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 180px;
        position: relative;
    }
    .group-69 {
        flex-shrink: 0;
        width: 365.91px;
        height: 116.33px;
        position: relative;
        overflow: visible;
        aspect-ratio: 365.91/116.33;
    }
    .frame-1000011402 {
        display: flex;
        flex-direction: column;
        gap: 75px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 572px;
        position: relative;
    }
    .a-message-from-mikkee-ceo-of-b-otag-technology {
        color: #ffffff;
        text-align: center;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 44px;
        letter-spacing: -0.015em;
        font-weight: 700;
        position: relative;
        align-self: stretch;
        height: 136px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ellipse-5 {
        width: 245px;
        height: 245px;
        border-radius: 50%;
        background: linear-gradient(to left, rgb(18, 22, 29), rgb(18, 22, 29));
        overflow: hidden; /* Ensures image stays inside the circle */
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ellipse-5 img {
        width: 100%;
        object-fit: cover;
        position: relative;
        top: 35px;
    }
    .frame-427319151 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        width: 787.5px;
        height: 884.95px;
        position: relative;
    }
    .frame-1000011042 {
        background: linear-gradient(rgb(211 126 0 / 22%) 0%, rgba(12, 12, 12, 0.2) 20%),
            linear-gradient(to left, rgb(20, 25, 34), rgb(20, 25, 34));
        padding: 68.54px 50px 39.17px 50px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        align-self: stretch;
        flex: 1;
        position: relative;
        overflow: hidden;
    }
    .frame-1000011045 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011376 {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011389 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }

    .frame-1000011377 {
        display: flex;
        flex-direction: column;
        gap: 56px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011185 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .text {
        color: #d1d1d1;
        text-align: left;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .text-span {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 20px;
        line-height: 24px;
        font-weight: 400;
    }
    .text-span2 {
        color: #d1d1d1;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
    }
    .text-span3 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 20px;
        line-height: 24px;
        font-weight: 400;
    }
    .text-span4 {
        color: #d1d1d1;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
    }
    .text-span5 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 20px;
        line-height: 24px;
        font-weight: 400;
    }
    .text-span6 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }
    .text-span7 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        text-decoration: underline;
    }
    .text-span8 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }
    .text-span9 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        text-decoration: underline;
    }
    .text-span10 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }
    .my-signature-white-1-1 {
        flex-shrink: 0;
        width: 243px;
        height: 46px;
        position: absolute;
        left: -40px;
        object-fit: contain;
        aspect-ratio: auto;
        bottom: 100px;
    }
    .x-close {
        flex-shrink: 0;
        width: 45px;
        height: 45px;
        position: absolute;
        right: 15.5px;
        top: 16px;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
`;
//#endregion

export default function WelcomeDialog() {
    //#region VARS
    const { setShowWelcomePopup, setShowDownloadAppPopup, setIsPwaInstalled } = React.useContext(AppContext);
    //#endregion

    //#region METHODS
    const getCookie = name => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
    };

    const closePopup = () => {
        setShowWelcomePopup(false);
        if (!getCookie("hideDownloadDialog")) {
            setShowDownloadAppPopup(true);
        }
        const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
        setIsPwaInstalled(isStandalone);
    };
    //#endregion

    return (
        <StyledWelcomeDialog className="popup">
            <div className="frame-1000011177">
                <div className="frame-427319123">
                    <div className="frame-1000011398">
                        <img className="group-69" src={LoginTopImg} alt="" />
                    </div>
                    <div className="frame-1000011402">
                        <div className="a-message-from-mikkee-ceo-of-b-otag-technology">
                            A message from Mikkee,
                            <br />
                            CEO of BOtag Technology
                        </div>
                        <div className="ellipse-5">
                            <img src={Mikkee} alt="" />
                        </div>
                    </div>
                </div>
                <div className="frame-427319151">
                    <div className="frame-1000011042">
                        <div className="frame-1000011045">
                            <div className="frame-1000011376">
                                <div className="frame-1000011389">
                                    <div className="frame-1000011377">
                                        <div className="frame-1000011185">
                                            <div className="text">
                                                <span>
                                                    <span className="text-span">Hey</span>{" "}
                                                    <span className="text-span2">
                                                        {localStorage.getItem("userFirstName")}
                                                    </span>
                                                    <span className="text-span3">
                                                        ,
                                                        <br />
                                                        <br />
                                                        On behalf of the entire BOtag team, I want to extend my
                                                        heartfelt thanks for joining our trial period as an early
                                                        partner.
                                                        <br />
                                                        <br />
                                                        Your commitment to innovation is critical as we work together to
                                                        revolutionize retail.
                                                        <br />
                                                        We designed BOtag’s platform with your success in mind, ensuring
                                                        that your digital engagement leads to actionable intelligence
                                                        and increased sales.
                                                        <br />
                                                        <br />
                                                        During the trial, we’ll continuously update BOtag based on your
                                                        feedback. If something isn’t quite right, we’ll fix it, and new
                                                        features will be activated gradually until we’re fully ready for
                                                        our big August launch as AW25 collection hits the road.
                                                        <br />
                                                        <br />
                                                        Your feedback is crucial, and together, we will refine and
                                                        improve the platform to better serve the evolving retail
                                                        landscape.
                                                        <br />
                                                        <br />
                                                        Thank you again for your trust and commitment. Let’s shape the
                                                        future of retail together.
                                                        <br />
                                                        <br />
                                                        Let’s
                                                    </span>{" "}
                                                    <span className="text-span4">BO</span>
                                                    <span className="text-span5">
                                                        !
                                                        <br />
                                                    </span>
                                                    <span className="text-span6">
                                                        <br />
                                                        Best regards,
                                                        <br />
                                                        <br />
                                                        <br />
                                                        Mikkee Caldeira
                                                        <br />
                                                    </span>
                                                    <span className="text-span7">+47 973 08 908</span>
                                                    <span className="text-span8">
                                                        <br />
                                                    </span>
                                                    <span className="text-span9">mikkee@botag.no</span>
                                                    <span className="text-span10">
                                                        <br />
                                                        CEO, BOtag Technology BV
                                                    </span>
                                                </span>
                                            </div>
                                            <img className="my-signature-white-1-1" src={CeoSignature} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img className="x-close" src={CloseBtn} alt="" onClick={() => closePopup()} />
        </StyledWelcomeDialog>
    );
}
